import React from 'react';
import './AboutUs.css';
import { FaShippingFast, FaUsers, FaMedal } from 'react-icons/fa';
import mooseMascot from '../assets/images/about-us/mascots.png';
import familyPicture from '../assets/images/about-us/store-front.png';
import flooringDisplay from '../assets/images/about-us/flooring-display.png';
import shippingDesplay from '../assets/images/about-us/customer-service.png';
import flagCad from '../assets/images/about-us/canada-flag.png';



function AboutUs() {
  return (
    <div className="about-us-container">
      <div className="about-us-content">
        <div className="about-us-left">
          <h1>About Us</h1>
          <div className="mascot-image">
            <img 
              src={mooseMascot}
              alt="FlooringDeals Moose Mascot" 
              className="img-fluid" 
            />
          </div>
        </div>
        
        <div className="about-us-right">
          <section className="info-section">
            <div className="section-text">
              <h2 className="section-title">Our Story:</h2>
              <p className="section-content">
                Born in Mississauga, serving all of Canada hdmovietoday.xyz was built
                to make premium flooring affordable and accessible
              </p>
            </div>
            <div className="section-image">
              <img 
                src={familyPicture} 
                alt="FlooringDeals Family" 
                className="img-fluid" 
              />
            </div>
          </section>

          <section className="info-section">
            <div className="section-text">
              <h2 className="section-title">What we believe:</h2>
              <p className="section-content">
                Real spaces, real people. We help Canadians build beautiful, lasting homes
                one floor at a time.
              </p>
            </div>
            <div className="section-image">
              <img 
                src={flooringDisplay} 
                alt="Flooring Display" 
                className="img-fluid" 
              />
            </div>
          </section>

          <section className="info-section">
            <div className="section-text">
              <h2 className="section-title">Our Advantage:</h2>
              <p className="section-content">
                Top-rated service, unbeatable prices and expert guidance every step of the way.
              </p>
            </div>
            <div className="section-image">
              <img 
                src={shippingDesplay} 
                alt="Customer Service" 
                className="img-fluid" 
              />
            </div>
          </section>

          <div className="divider"></div>

          <section className="advantage-icons">
            <div className="advantage-icon-item">
              <FaUsers className="icon" />
              <h3>1000s of happy customers</h3>
            </div>
            <div className="advantage-icon-item">
              <FaShippingFast className="icon" />
              <h3>Fast Coast-to-Coast Shipping</h3>
            </div>
            <div className="advantage-icon-item">
              <FaMedal className="icon" />
              <h3>10+ Years of Flooring Expertise</h3>
            </div>
          </section>
        </div>
      </div>

      <div className="footer-banner">
        <p>
          Visit us online or in-store. hdmovietoday.xyz — Canada's trusted flooring source. <img src={flagCad} alt="Canadian Flag" className="canada-flag" />
        </p>
      </div>
    </div>
  );
}

export default AboutUs;
